import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getUserPolicy = (payload) => {
  return axios
    .get(`${URL_ORI}/api/UserPolicy/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createUserPolicy = (payload) => {
  return axios.post(`${URL_ORI}/api/UserPolicy`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdUserPolicy = (id) => {
  return axios
    .get(`${URL_ORI}/api/UserPolicy/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateUserPolicy = (payload) => {
  return axios.put(`${URL_ORI}/api/UserPolicy`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteUserPolicy = (payload) => {
  return axios.delete(`${URL_ORI}/api/UserPolicy`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createOfficeMapping= (payload) => {
  return axios.post(`${URL_ORI}/api/UserPolicy/addoffice`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const deleteOfficeMaping= (payload) => {
  return axios.delete(`${URL_ORI}/api/UserPolicy/deleteOffices`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};


